export interface IMarginCategory {
  marginCategoryTypeId: number;
  marginCategoryName: string;
  revenueAccountId: number | null;
  revenueAccountName: string;
  revenueItemId: number | null;
  commissionAccountId: number | null;
  commissionAccountName: string;
  generalDealCostsAccountId: number | null;
  generalDealCostsAccountName: string;
}

export const MarginCategoryImplementation = {
  getDefault(): IMarginCategory {
    return {
      marginCategoryTypeId: 0,
      marginCategoryName: '',
      revenueAccountId: null,
      revenueAccountName: '',
      revenueItemId: null,
      commissionAccountId: null,
      commissionAccountName: '',
      generalDealCostsAccountId: null,
      generalDealCostsAccountName: '',
    };
  },
};
